import ScrollContainer from "react-indiana-drag-scroll";
import styled from "styled-components";

import { Container } from "components/ui";

import { media } from "constants/media";

export const StyledContainer = styled(Container)`
    flex-direction: column;
    padding: 32px 0;

    h2 {
        margin-bottom: 16px;
        padding: 0 24px;
        word-break: auto-phrase;
    }

    ${media.mdUp} {
        margin: 0 auto;
        max-width: 1248px;
        padding: 80px 0;

        h2 {
            margin-bottom: 32px;
        }
    }
`;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
export const StyledScrollContainer = styled(ScrollContainer)`
    cursor: grab;
    display: flex;
    height: 412px;
    padding: 0 24px;
    position: relative;

    ${media.mdUp} {
        cursor: unset;
        height: 424px;
        justify-content: center;
        margin: 0 auto;
        max-width: 1248px;
        width: 100%;
    }
`;

export const IconWrapper = styled.div<{ selected: boolean }>`
    align-items: center;
    background: ${({ selected }) =>
        selected ? "var(--color-primary)" : "transparent"};
    border-radius: 50%;
    display: flex;
    height: 112px;
    justify-content: center;
    outline: ${({ selected }) =>
        selected ? 0 : "1px solid var(--color-grey-45);"};
    width: 112px;

    ${media.mdUp} {
        cursor: pointer;
    }
`;

export const StyledStep = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 1px 24px 0 0;
    position: relative;

    ${media.mdUp} {
        margin-right: 0;
        width: 100%;
    }
`;

export const Title = styled.p<{ selected: boolean }>`
    font-size: 16px;
    line-height: 24px;
    margin-top: 24px;
    // eslint-disable-next-line
    -webkit-text-stroke: ${({ selected }) =>
        selected ? "1px var(--color-black);" : "0"};
    transition: all 250ms linear;
`;

export const Description = styled.p<{ index: number }>`
    background: var(--color-grey-50);
    border-radius: 24px;
    bottom: 0;
    font-weight: 600;
    left: ${({ index }) => 137 * index + 24}px;
    min-height: 168px;
    padding: 24px 20px;
    position: absolute;
    right: 24px;
    width: 272px;

    ::before {
        background-color: var(--color-grey-50);
        clip-path: polygon(50% 0, 100% 100%, 0 100%);
        content: "";
        display: block;
        height: 20px;
        left: 32px;
        position: absolute;
        top: -19px;
        width: 40px;
    }

    ${media.mdUp} {
        font-size: 20px;
        left: 24px;
        line-height: 32px;
        max-width: 1248px;
        padding: 56px;
        width: calc(100% - 48px);

        ::before {
            left: ${({ index }) => 245 * index + 88}px;
        }
    }
`;
